function hasTeamsCredits({ teams, creditType }) {
  if (!creditType) {
    return false;
  }

  return creditType === 'TEAM' && teams && teams.length;
}

export default hasTeamsCredits;